import styled from 'styled-components';
import { COLORS } from 'styles/constants';
import tw from 'tailwind-styled-components';
import { Text as Paragraph, Title } from '../Typography';

export const CustomTab = styled.div`
  margin-left: 19px;
  margin-right: 19px;
  cursor: grab;
  .react-tabs__tab-panel--selected {
    display: inline-block;
  }
  .react-tabs__tab {
    opacity: 0.7;
    border: 0;
    bottom: 0;
    border-bottom: 3px solid #d4ded3;
    margin: 0;
    padding: 10px 0;
    white-space: nowrap;
    color: ${COLORS.primary};

    :first-child {
      padding: 10px 0;
      :after {
        content: none;
      }
    }
  }
  .react-tabs__tab-list {
    border: 0;
    margin-bottom: 20px;
    margin-top: 20px;
    display: flex;
  }
  .react-tabs__tab--selected {
    opacity: 1;
    border-bottom-color: #292b29;
    color: #292b29;
  }
  .react-tabs__tab:hover {
    opacity: 1;
    cursor: pointer;
    color: #292b29;
  }
`;

export const Heading = tw(Title)`
  font-normal
  `;

export const ColHeading = tw.div`
  align-top
`;

export const ColHeadList = tw.div`
  p-4
  h-70
  flex
  items-center
  ${(p: { line?: string }) => (p.line === 'odd' ? 'bg-lightBrown' : '')}
`;

export const ColData = tw.div`
  flex
  items-center
  h-70
  p-4
  ${(p: { line?: string }) => (p.line === 'odd' ? 'bg-lightBrown' : '')}
`;

export const MobileLabel = tw(Paragraph)`
  font-medium
`;

export const MainTitle = tw(Title)`
  text-center
  mb-9
  md:mb-10
`;
export const SeparatorContainer = styled.div`
  padding: 10px 20px;
  border-bottom: 3px solid #d4ded3;
`;
export const SeparatorDot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background-color: #d4ded3;
  display: inline-block;
`;

export const TwDivTab = tw.div`
w-full
overflow-y-auto
sticky sm:top-14
md:top-20
bg-white z-22
`;

export const StyledTabDiv = styled(TwDivTab as any)`
  @media (min-width: 768px) {
    ::-webkit-scrollbar {
      display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`;
